import React from 'react';

import { FloatingLabel, FormText } from '../../../../components/form';

import { Event } from '../../../../types';

interface Props {
  data: Partial<Event>;
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  errors: Record<string, string>;
}

const ProjectDatesSelector: React.FC<Props> = (props) => {
  const { data, handleChange, errors } = props;

  return (
    <div className="flex flex-col sm:flex-row gap-6 sm:gap-10">
      <div className="w-full sm:w-1/2">
        <FloatingLabel
          label="Start Date"
          type="date"
          name="startDate"
          value={data.startDate ?? ''}
          onChange={handleChange}
          isInvalid={!!errors.startDate}
          errMsg={errors.startDate}
          required
        />
        <FormText text="You won't be able to edit the project after it starts" />
      </div>

      <div className="w-full sm:w-1/2">
        <FloatingLabel
          label="End Date"
          type="date"
          name="endDate"
          value={data.endDate ?? ''}
          onChange={handleChange}
          isInvalid={!!errors.endDate}
          errMsg={errors.endDate}
          required
        />

        <FormText text="Attendees won't be able to check in after the project ends" />
      </div>
    </div>
  );
};

export default ProjectDatesSelector;
